<template>
  <div
    aria-hidden="true"
    class="relative grid shrink-0 select-none place-items-center overflow-hidden rounded text-center text-xs font-black"
    :class="[size === 'default' && `size-5`, size === 'large' && `size-8`]"
    :style="{
      'background-color': newsletter.icon ? 'inherit' : colors?.background,
      color: newsletter.icon ? 'inherit' : colors?.text,
    }"
  >
    <span>{{ newsletter.name[0] || "?" }}</span>

    <img
      v-if="newsletter.icon && imageStatus !== 'error'"
      :key="newsletter.icon"
      :src="newsletter.icon"
      class="absolute inset-0 size-full object-cover"
      @load="imageStatus = 'success'"
      @error="imageStatus = 'error'"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getAccessibleColorPair } from "@/lib/color-utils";
import { writable } from "@/lib/dirty";

const props = withDefaults(
  defineProps<{
    newsletter: {
      name: string;
      icon?: string;
      tint_color?: string;
    };
    size?: "default" | "large";
  }>(),
  {
    size: "default",
  }
);

// If it fails to load we'll just give up and show our placeholder
const imageStatus = writable<"idle" | "pending" | "success" | "error">(() => {
  return props.newsletter.icon ? "pending" : "idle";
});

const colors = computed(() =>
  getAccessibleColorPair(props.newsletter.tint_color || "#0069FF")
);
</script>
